export default "__VITE_ASSET__Bsgx2kts__"